import _extends from "@babel/runtime/helpers/extends";
import React, { createContext, useContext, useReducer } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var initialState = {
  activeKey: '',
  data: []
};
export var reducer = (state, action) => {
  return _extends({}, state, action);
};
export var Context = /*#__PURE__*/createContext({
  state: initialState,
  dispatch: () => null
});
export var Provider = _ref => {
  var children = _ref.children,
    init = _ref.init;
  var _useReducer = useReducer(reducer, init || initialState),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  return /*#__PURE__*/_jsx(Context.Provider, {
    value: {
      state,
      dispatch
    },
    children: children
  });
};
export function useDataContext() {
  var _useContext = useContext(Context),
    state = _useContext.state,
    dispatch = _useContext.dispatch;
  return _extends({}, state, {
    state,
    dispatch
  });
}